up.compiler('[filter]', function(filterForm) {
  const resetButton = filterForm.querySelector('[filter--reset]')
  const queryInput = filterForm.querySelector('[filter--query]')
  resetButton.addEventListener('click', function() {
    queryInput.value = ''
    up.emit(queryInput, 'change')
    queryInput.focus()
  })
})
